import React, { Component } from 'react';


import NumberFormat from 'react-number-format';
import {transactionID, clientInfo, formatAmount} from '../../../services/helpers';
import axios from 'axios';
import Swal from 'sweetalert2';




class RechargeResume extends Component {

    constructor(props) {
        super(props);

        axios.defaults.headers.common['Authorization'] = "Bearer " + clientInfo().accessToken;
        axios.defaults.headers.common['Content-Type'] = "application/json";

        this.state = {
            scheduledRecharge: false
        }
    }

    handleCheckboxCcheduled = event => {
        this.setState({ scheduledRecharge: !event.target.checked });
    }

    handleSendRecharge = () => {

        const {scheduledRecharge} = this.state;
        //this.props.setRechargeProgram(scheduledRecharge);
        this.props.sendRecharge();

    }
    

    componentDidMount = async () => {


    }

    render() {

        const {number, amount, payment, scheduledRecharge} = this.props.resume;

        return (

            <div className="purchase-resume step">
                    {/* <h2>Resumo</h2> */}

                    <ul className="purchase-resume-container">
                        <li>
                            <div className="recharge-change-number-container">
                                <small>Valor</small>
                                <a  className="recharge-change-number cursor-pointer" onClick={() => { this.props.step(2) }}>Trocar</a>
                            </div>
                            <div className="d-flex recharge-change-number-display">
                                <div>
                                    <img className="resume-amount-image" src={amount.note} />
                                    {/* {amount === 0 || <img className="resume-amount-image" src={this.state.createRecharge.note} />} */}
                                </div>
                            </div>
                        </li>
                        <li>
                            <div className="recharge-change-number-container">
                                <small>Número</small>
                                <a  className="recharge-change-number cursor-pointer" onClick={() => { this.props.step(1) }}>Trocar</a>
                            </div>
                            <p>{number}</p>
                        </li>
                        <li>
                            <div className="recharge-change-number-container">
                                <small>Pagamento</small>
                                <a  className="recharge-change-number cursor-pointer" onClick={() => { this.props.step(3) }}>Trocar</a>
                            </div>

                            <div className="d-flex flex-item-align-center">
                                <div>
                                    {
                                        payment.flag &&
                                        <img className="resume-payment-flag" src={require(`../../../images/payments/${payment.flag.toLocaleLowerCase()}.svg`)} />
                                    }
                                </div>
                                <div>
                                    Final {payment.digFour}
                                </div>
                            </div>


                        </li>
                        <li>
                            <div className="recharge-change-number-container">
                                <small>Total</small>
                                <a href="#" className="recharge-amount-total color-success">{formatAmount(amount.value)}</a>
                            </div>
                        </li>
                    </ul>

                    {
                        payment.type === 'D' ||
                        <div className={`${this.state.showProgramBanner ? "" : "d-none"} ${!amount.promotion ? "" : "d-none"}`}>
                            <div className="resume-scheduled">
                                <div>
                                    Ativar Recarga programada <br />
                                    <small>Acumule o que não usou para o próximo mês</small>
                                </div>

                                <div>
                                    <label className="switch">
                                        <input type="checkbox" checked={scheduledRecharge} onChange={this.handleCheckboxCcheduled} />
                                        <span className="slider round"></span>
                                    </label>
                                </div>

                            </div>
                            <div className="resume-scheduled" style={{ justifyContent: 'flex-end', marginRight: '20px' }}>
                                <img className="" src={require('../../../images/banner-ganha-1gb.png')} />
                            </div>
                        </div>
                    }
                    <br />

                    <button className="btn btn-success" onClick={() => { this.handleSendRecharge() }} style={{ margin: '0 auto' }}>CONFIRMAR</button>

            </div>

        );
    }

}

export default RechargeResume